// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class ParallelTableService {
  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public getTasksParallelByTaskFatherId<T>(taskId: any, userId: string): Observable<T> {
    const params = {
      taskId: taskId,
      userId: JSON.stringify(userId),
    };

    const url = this.Global.services.task.draft();

    return this.sendService.get(url, { params });
  }

  public getTasksByIds<T>(taskIds: any): Observable<T> {
    const params = {
      ids: JSON.stringify(taskIds),
    };

    const url = this.Global.services.task.get();

    return this.sendService.get(url, { params });
  }
}
